import React from "react";
import Phone from "../FormInputFields/Phone";
import TextArea from "../FormInputFields/TextArea";
import TextInput from "../FormInputFields/TextInput";
import Number from "../FormInputFields/Number";
import Email from "../FormInputFields/Email";
import LongNumber from "../FormInputFields/LongNumber";
import Decimal from "../FormInputFields/Decimal";
import Percentage from "../FormInputFields/Percentage";
import DatePick from "../FormInputFields/DatePick";
import DateTime from "../FormInputFields/DateTime";
import OnAndOffField from "../FormInputFields/OnAndOffField";
import Checkbox from "../FormInputFields/Checkbox";
import TimePick from "../FormInputFields/TimePick";
import TextHTML from "../FormInputFields/TextHTML";
import Radio from "../FormInputFields/Radio";
import MultiChoose from "../FormInputFields/MultiChoose";
import Password from "../FormInputFields/Password";
import FileUpload from "../FormInputFields/FileUpload";
import ImageUpload from "../FormInputFields/ImageUpload";
import PagesPickList from "./PickList";
import PagesMultiselect from "./MultiSelect";
import PagesCurrency from "./Currency";
import Lookup from "./Lookup";
import MultiLookup from "./MultiLookup";

const PagesInputFields = (props) => {
  
  switch (props.type) {
  
    case"Picklist":
      return <PagesPickList {...props} />;
    case"PickList":
      return <PagesPickList {...props} />;
    case "Password":
      return <Password {...props} />;
    case "Phone":
      return <Phone {...props} />;
    case "Email":
      return <Email {...props} />;
    case "TextArea":
      return <TextArea {...props} />;
    case "TextHTML":
      return <TextHTML {...props} />;
    case "TextInput":
      return <TextInput {...props} />;
    case "PostalCode":
      return <TextInput {...props} />;
    case "Number":
      return <Number {...props} />;
    case "LongNumber":
      return <LongNumber {...props} />;
    case "Decimal":
      return <Decimal {...props} />;
    case "Percentage":
      return <Percentage {...props} />;
    case "Currency":
      return <PagesCurrency {...props} />;
    case "DatePick":
      return <DatePick {...props} />;
    case "Date":
      return <DatePick {...props} />;
    case "DateTime":
      return <DateTime {...props} />;
    case "Reminder":
      return <DateTime {...props} />;
    case "TimePick":
      return <TimePick {...props} />;
    case "OnAndOffField":
      return <OnAndOffField {...props} />;
    case "Multiselect":
      return <PagesMultiselect {...props} />;
    case "MultiSelect":
      return <PagesMultiselect {...props} />;
    case "MultiChoose":
      return <MultiChoose {...props} />;
    case "Checkbox":
      return <Checkbox {...props} />;
    case "FileUpload":
      return <FileUpload {...props} />;
    case "ImageUpload":
      return <ImageUpload {...props} />;
    case "Radio":
      return <Radio {...props} />;
    case "Lookup":
      return <Lookup {...props} />;
    case "MultiLookup":
      return <MultiLookup {...props} />;
    default:
      return <TextInput {...props} />;
  }
};

export default PagesInputFields;


